import { arrayOf, func, number, oneOf } from 'prop-types';
import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';

import { attachmentShape } from '../../prop-types';
import AttachmentsGrid from '../AttachmentsGrid';
import { ALL_ATTACHMENT_TYPES, ATTACHMENT_LABELS } from '../constants';
import AttachmentGroupModal from './AttachmentGroupModal';

const maxRows = 3;

function AttachmentGroup({ type, files, colCount, onDeleteFileSuccess }) {
  if (!files || files.length === 0) return null;
  const maxFileCount = colCount * maxRows;
  const label = `${ATTACHMENT_LABELS[type]} (${files.length})`;
  return (
    <Card className="border-0">
      <CardHeader className="p-2 border rounded-top text-center">
        {label}
      </CardHeader>
      <CardBody className="p-2">
        <>
          <AttachmentsGrid
            onDeleteFileSuccess={onDeleteFileSuccess}
            files={files.slice(0, maxFileCount)}
            colCount={colCount}
          />
          {files.length > maxFileCount && (
            <div className="text-center">
              <AttachmentGroupModal
                header={label}
                files={files}
                onDeleteFileSuccess={onDeleteFileSuccess}
              />
            </div>
          )}
        </>
      </CardBody>
    </Card>
  );
}

AttachmentGroup.propTypes = {
  type: oneOf(ALL_ATTACHMENT_TYPES).isRequired,
  onDeleteFileSuccess: func.isRequired,
  files: arrayOf(attachmentShape.isRequired),
  colCount: number,
};

AttachmentGroup.defaultProps = {
  files: undefined,
  colCount: 2,
};

export default AttachmentGroup;
